import React__default from 'react';
import classnames from 'classnames';
import { Popper } from 'react-popper';
import { useTooltip } from './TooltipContext.js';

const TooltipContent = ({ id , placement ='top' , boundariesElement ='scrollParent' , children ,  })=>{
    const { isActive , setIsActive , isTouch  } = useTooltip();
    const [tooltipHovered, setTooltipHovered] = React__default.useState(false);
    const handleMouseOver = React__default.useCallback(()=>{
        !isTouch && setTooltipHovered(true);
    }, [
        isTouch
    ]);
    const handleMouseLeave = React__default.useCallback(()=>{
        !isTouch && setTooltipHovered(false);
    }, [
        isTouch
    ]);
    return /*#__PURE__*/ React__default.createElement("div", {
        "aria-live": "polite",
        id: id
    }, (isActive || tooltipHovered) && /*#__PURE__*/ React__default.createElement(Popper, {
        placement: placement,
        modifiers: {
            preventOverflow: {
                enabled: true,
                boundariesElement,
                padding: 0
            }
        }
    }, ({ ref , style , placement: computedPlacement  })=>/*#__PURE__*/ React__default.createElement("div", {
            "aria-hidden": !isActive,
            ref: ref,
            style: style,
            "data-placement": computedPlacement,
            className: classnames('tooltip__message', `tooltip__message-placement--${computedPlacement}`),
            onMouseOver: handleMouseOver,
            onMouseLeave: handleMouseLeave,
            onFocus: ()=>null
            ,
            onBlur: ()=>setIsActive(false)
        }, children)
    ));
};

export { TooltipContent };
//# sourceMappingURL=TooltipContent.js.map
